import React, { Component } from "react";
import "./Projects.css";
// import projects from "./projectsData";
import classNames from "classnames";

export default class ProjectsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      activeProject: 1,
      loading: true,
      error: null
    };
  }


  componentDidMount() {
    // 👇 Replace this with your own API link (e.g. from Mocki)
    const apiUrl = "https://mocki.io/v1/5a794508-c19f-4bbd-b481-5cd57c988c34";

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((data) => {
        // adjust based on your JSON structure:
        // if your file looks like { "projects": [ ... ] } → use data.projects
        this.setState({
          projects: data.projects,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching project data:", error);
        this.setState({ error, loading: false });
      });
  }



  handleProjectClick = (project) => {
    this.setState({
      activeProject: project,
    });
  };

  renderContent = (projects) => {
    return projects.map((project, index) => (
      <div key={index} className={`project-sub-container ${index + 1}`}>
        <h3>{project.title}</h3>
        <img src={project.image} alt={project.title} />
        <div className="description">{project.description}</div>
        <div className="link-container">
          <a href={project.github} target="_blank" rel="noopener noreferrer">
            GITHUB
          </a>
          <a href={project.demo} target="_blank" rel="noopener noreferrer">
            DEMO
          </a>
        </div>
      </div>
    ));
  };

  render() {
    const { activeProject, projects, loading, error } = this.state;

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error loading data.</p>;
    if (!projects.length) return <p>No projects available.</p>;

    const projectItems = projects.map((p, i) => `PROJECT ${i + 1}`);

    return (
      <div className="project-menu">
        <div className="project-items-container">
          {projectItems.map((item, index) => (
            <div
              key={index}
              className={classNames("project-item", {
                activeProject: activeProject === index + 1,
              })}
              onClick={() => this.handleProjectClick(index + 1)}
            >
              <h2 className="title">{item}</h2>
            </div>
          ))}
        </div>

        <div className="project-sub-container">
          {/* render only the active project */}
          {this.renderContent([projects[activeProject - 1]])}
        </div>
      </div>
    );
  }
}